import React from 'react'
import { NavLink } from 'react-router-dom'

import { Icon, Loader } from '@fourthwall/components'
import { ArrowLongLeftIcon } from '@fourthwall/icons'

import * as S from './EditorPanelHeader.styled'
import type { Props } from './types'

export const EditorPanelHeader = ({ title, to, actionContent, isLoading, onClick }: Props) => {
  const renderIcon = () => {
    if (isLoading) {
      return (
        <S.LoaderContainer>
          <Loader />
        </S.LoaderContainer>
      )
    }

    if (onClick) {
      return (
        <S.BackButton onClick={onClick} data-testid="EditorPanelHeader.ArrowIcon">
          <Icon component={ArrowLongLeftIcon} height={16} />
        </S.BackButton>
      )
    }

    if (to) {
      return (
        <S.BackButton as={NavLink} to={to} data-testid="EditorPanelHeader.ArrowIcon">
          <Icon component={ArrowLongLeftIcon} height={16} />
        </S.BackButton>
      )
    }
  }

  return (
    <S.Container>
      <S.Wrapper>
        {renderIcon()}
        <S.Title>{title}</S.Title>
        {actionContent && <div>{actionContent}</div>}
      </S.Wrapper>
    </S.Container>
  )
}
